import { render, staticRenderFns } from "./AgentDashboard.vue?vue&type=template&id=3296c064&scoped=true&lang=html&"
import script from "./AgentDashboard.vue?vue&type=script&lang=js&"
export * from "./AgentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AgentDashboard.vue?vue&type=style&index=0&id=3296c064&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3296c064",
  null
  
)

export default component.exports